import './setupMapboxWorker'
import React from 'react'
import ReactDOM from 'react-dom/client'
import posthog from 'posthog-js'
import './index.css'
import App from './App'

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    bootstrap: {},
    advanced_disable_feature_flags_on_first_load: false,
    session_recording: {
      maskAllInputs: true
    }
  })
  // Expose posthog on window for DevTools debugging in non-production builds
  // only. The npm import does not attach itself, so this is purely a dev
  // convenience for inspecting distinct_id / person properties / flags. In
  // production we keep the instance module-scoped to minimise the surface
  // available to third-party scripts and XSS payloads on the same origin.
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    window.posthog = posthog
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
